import { jsonParse, jsonStringify } from 'utils/json';

import { RECENT_SEARCHES_STORAGE_KEY } from '../../UniversalSearch.constants';

export const readRecentItems = () => {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_STORAGE_KEY);

    return stored ? jsonParse(stored) : [];
  } catch {
    return [];
  }
};

export const persistRecentItems = items => {
  try {
    localStorage.setItem(RECENT_SEARCHES_STORAGE_KEY, jsonStringify(items));
  } catch {
    // localStorage unavailable — silently ignore
  }
};
